export function removeTrailingSlash(s: string): string {
  if (typeof s !== "string") {
    return "";
  }

  return s.endsWith("/") ? s.substring(0, s.length - 1) : s;
}

export function removeLeadingSlash(s: string): string {
  if (typeof s !== "string") {
    return "";
  }

  return s.startsWith("/") ? s.slice(1) : s;
}
